import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;

  min-height: 100%;
  padding: 32px;
`;
